import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_FUND_ACCOUNTS_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_LIST_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/fund-accounts`,
    method: 'GET',
  })
);

export default apiCall;
